'use client';

import React, { useContext } from 'react';
import { AudioStockItem } from 'search-gateway-client';
import { twMerge } from 'tailwind-merge';

import { Text } from '@videoblocks/design-system';
import { ClickLabel } from '@videoblocks/events-ts/lib/storyblocks/content/ClickLabelEnum';

import { sendBeacon } from '../../common/utils';
import StockItemCardContext from '../cards/AudioStockItemCard/context/StockItemCardContext';
import sendEvent from '../events/StockItemClickEvent';
import { StockItemContext } from './StockItemTypes';

interface AudioPlayerTitleProps {
    wrapperClassName?: string;
    className?: string;
    headerClassName?: string;
    openDetailsInNewWindow?: boolean;
    stockItem: AudioStockItem;
    position?: number; // i.e. index in search results
}

const AudioPlayerTitle = (props: AudioPlayerTitleProps) => {
    const { stockItemContext } = useContext(StockItemCardContext);

    const handleStockItemClick = () => {
        const stockItemId = props.stockItem?.id;
        // todo: implement clickEvent api handler for beacons (see LNL-714)
        const beaconSent = sendBeacon('/api/audio/stockItemClickEvent/details', stockItemId, props.position as number);

        if (!beaconSent) {
            void sendEvent(
                props.stockItem,
                props.position as number,
                ClickLabel.DETAILS,
                document.referrer,
                window.location.href,
            );
        }
    };

    return (
        <span className={twMerge('text-black font-bold text-sm', props.wrapperClassName)}>
            <Text fontSize="sm" fontWeight="bold" asChild>
                {stockItemContext === StockItemContext.DETAILS_PLAYER ? (
                    <span>{props.stockItem.title}</span>
                ) : (
                    <a
                        href={props.stockItem.detailsUrl}
                        target={props.openDetailsInNewWindow ? '_blank' : '_self'}
                        onClick={handleStockItemClick}
                        className={twMerge('hover:underline', props.className)}
                    >
                        {props.stockItem.title}
                    </a>
                )}
            </Text>
        </span>
    );
};

export default AudioPlayerTitle;
